import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found | The Energy-Safe Method';

    let robots = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex, nofollow';

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.remove();

    return () => {
      robots.content = 'index, follow';
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 bg-background-50">
      <p className="font-heading text-8xl md:text-9xl font-bold text-primary-200 select-none" aria-hidden="true">
        404
      </p>
      <h1 className="font-heading text-2xl md:text-3xl font-semibold text-primary-800 mt-4">
        We couldn&apos;t find that page
      </h1>
      <p className="mt-3 text-sm text-foreground-500 max-w-md leading-relaxed">
        The page you&apos;re looking for may have moved or no longer exists. Here are a few helpful places
        to continue your journey.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="bg-primary-500 text-background-50 px-6 py-3 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          Go to Home
        </Link>
        <Link
          to="/blog"
          className="border border-primary-300 text-primary-700 px-6 py-3 rounded-lg font-medium text-sm hover:bg-primary-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          Read the Blog
        </Link>
        <a
          href="https://calendly.com/federicatedeschi3/new-meeting"
          target="_blank"
          rel="noopener noreferrer"
          className="border border-primary-300 text-primary-700 px-6 py-3 rounded-lg font-medium text-sm hover:bg-primary-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          Book a Conversation
        </a>
      </div>
    </div>
  );
}